import { render, staticRenderFns } from "./lookover.vue?vue&type=template&id=bdb9c18a&scoped=true&"
import script from "./lookover.vue?vue&type=script&lang=js&"
export * from "./lookover.vue?vue&type=script&lang=js&"
import style0 from "./lookover.vue?vue&type=style&index=0&id=bdb9c18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb9c18a",
  null
  
)

export default component.exports